import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth, formatApiError } from "../lib/auth";
import { BrandBlock, Footer } from "../components/Brand";

export default function LoginPage() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) nav(loc.state?.from || "/dashboard", { replace: true });
  }, [user, nav, loc.state]);
  if (user) return null;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, password);
      nav(loc.state?.from || "/dashboard", { replace: true });
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally { setBusy(false); }
  };

  return (
    <div className="login-wrap" style={{ flexDirection: "column", gap: 8 }}>
      <form className="card login-card" onSubmit={submit} data-testid="login-form">
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}><BrandBlock size={26} center testId="login-brand" /></div>
        <p className="muted" style={{ textAlign: "center", fontSize: 14, margin: "0 0 10px" }}>Sign in to manage your cameras</p>
        <label className="label" htmlFor="email">Email</label>
        <input id="email" className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
        <label className="label" htmlFor="password">Password</label>
        <input id="password" className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
        {err && <div className="form-error" data-testid="login-error">{err}</div>}
        <button className="btn" type="submit" disabled={busy} style={{ width: "100%", justifyContent: "center", marginTop: 22 }} data-testid="login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <Footer />
    </div>
  );
}
